import { logger } from '../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../utils/dom'
import { LoginService } from '../services/login-service'
import { IdentityScreen, LoginRadiusWidget, LRWidgetType } from './base'

export class EmailValidationWidget extends LoginRadiusWidget {

    private validateEmailOptions = {
        onError: this.onError,
        onSuccess: this.onSuccess,
    }

    constructor(container: string, lrObject: any) {
        super()
        this.widgetType = LRWidgetType.VERIFY_EMAIL
        this.lrObject = lrObject
        this.container = container
        logger('info','Email validation widget created')
    }

    public initEmailValidation() {
        this.lrObject.init('verifyEmail', this.validateEmailOptions)
    }

    public onSuccess(response: any) {
        logger('info', response)

        // Success page
        DOMUtils.addClass(document.body, IdentityScreen.SUCCESS)
    }

    public onError(errors: any) {
        logger('error', errors)
        LoginService.sendSubmissionErrorAnalytics(errors, 'email-validation')
    }
}
